export default __webpack_public_path__ + "static/media/VISTAAR BOT PP.10175259.svg";